import { forwardRef, Ref, type SVGProps } from 'react';

const SvgHandSwipeIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.75 9.537v2.315m0-2.315V3.148c0-.767.634-1.389 1.417-1.389.782 0 1.416.622 1.416 1.39M5.75 9.536c0-.767-.634-1.389-1.417-1.389-.782 0-1.416.622-1.416 1.389v1.852c0 3.835 3.171 6.944 7.083 6.944s7.083-3.109 7.083-6.944V8.426c0-.767-.634-1.389-1.416-1.389-.783 0-1.417.622-1.417 1.389M8.583 3.148v5.926m0-5.926v3.24C8.583 5.623 9.218 5 10 5s1.417.622 1.417 1.389v.926m0 0v1.76m0-1.76c0-.767.634-1.389 1.416-1.389.783 0 1.417.622 1.417 1.389v1.111m0 0v.648"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgHandSwipeIcon);
export default ForwardRef;
